export const AVAILABLE_LANGUAGES = ["en", "fr"] as const;

export type InterfaceLanguageCode = typeof AVAILABLE_LANGUAGES[number];
